import {
  useMutationPostFlexiPlanUpgrade,
  useQueryGetFlexiPlanData,
} from 'services/payment/queries';
import { findFlexiPlan, findMonthPeriod } from 'utils/PaymentHelper';
import useMediaQuery from '../../Business/hooks/useMediaQuery';

type MonthlyPlanType = {
  currencyCode: string;
  freeQuantity: number;
  id: string;
  name: string;
  periodUnit: string;
  price: number;
  unit: string;
};

const useCreditLimitData = (chargebeeInstance) => {
  const { data: planData } = useQueryGetFlexiPlanData();
  const { mutate: postUpgrade } = useMutationPostFlexiPlanUpgrade();
  const { isMobile } = useMediaQuery();
  const monthlyPlan: MonthlyPlanType = planData
    ?.find(findFlexiPlan)
    ?.billings?.find(findMonthPeriod);
  const monthlyPlanSinglePrice = monthlyPlan?.price;
  const monthlyPlanId = monthlyPlan?.id;

  const handlePlanUpgrade = (selectedQuantity: number) => {
    // we need this since 1 package in Flexi Plan is free
    const quantity = selectedQuantity + 1;
    return new Promise((resolve, reject) => {
      postUpgrade(
        // @ts-ignore
        { planId: monthlyPlanId, quantity },
        {
          onSuccess: (data) => {
            if (isMobile) {
              chargebeeInstance?.current?.closeAll();
              window.location.replace(data?.metadata?.url);
            }
            return resolve(data);
          },
          onError: (error) => {
            reject(error);
          },
        },
      );
    });
  };

  return {
    monthlyPlan,
    monthlyPlanSinglePrice,
    handlePlanUpgrade,
  };
};

export default useCreditLimitData;
